// Asking for a reset link.
//
// The confirmation is worded so that it says the same thing whether or not the
// address is on an account — matching what the server does, which is answer
// identically either way.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ApiError, api } from '../api';
import { AuthCard, Banner, Field } from '../ui';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fields, setFields] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    setFields({});
    try {
      await api.requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message);
        setFields(err.fields);
      } else {
        setError('Something went wrong. Try again.');
      }
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AuthCard title="Check your email">
        <Banner kind="ok">
          If {email} is on a Dayboard account, a reset link is on its way. It works for two hours.
        </Banner>
        <p className="footnote">
          <Link to="/login">Back to sign in</Link>
        </p>
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Reset your password">
      {error && <Banner kind="error">{error}</Banner>}
      <form onSubmit={submit} noValidate>
        <Field
          label="Email"
          name="email"
          type="email"
          value={email}
          onChange={setEmail}
          error={fields.email}
          autoComplete="email"
          autoCapitalize="none"
          spellCheck={false}
          enterKeyHint="send"
        />
        <button className="btn-primary full" type="submit" disabled={busy}>
          {busy ? 'Sending…' : 'Send reset link'}
        </button>
      </form>
      <p className="footnote">
        <Link to="/login">Back to sign in</Link>
      </p>
    </AuthCard>
  );
}
